<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          ratingSetDetailsList: this.ratingSetDetailsList,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData= $event"
        v-on:save="saveHandler"
        v-on:cancel="cancelHandler"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RatingScaleSetForm from "../../../components/performance/ratingset/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": RatingScaleSetForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      pageTitle: this.$t('Setupratingset.editratingset'),
      pageTitleValue: "",
      formData: {
        rateset: null,
        description: null,
        disable: false,
        remark: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      ratingSetDetailsList: [],

      errMsg: "",
      isErr: false,
      loading: true,
      editMode: true,
      isConfirm: false,
    };
  },

  methods: {

    errorHandler($event) {
    this.isErr = $event.isErr;
    this.errMsg = $event.errMsg;
    },

    async loadRatingSetHandler() {
      const vm = this;

      try {
        const res = await this.$store.dispatch('get', {url: "/ratingset/" + vm.id});
        Object.assign(vm.formData, res.data.rec[0]);
        vm.pageTitleValue = res.data.rec[0].rateset;
      } catch (err) {
        vm.isErr = !vm.isErr;
        vm.errMsg = err;
      }
    },

    async loadRatingDetailsHandler() {
      const vm = this;

      try {
        const res = await this.$store.dispatch('get', {url: "/ratingsetdetails/" + this.id});
        vm.ratingSetDetailsList = res.data.rec;
      } catch (err) {
        vm.isErr = !vm.isErr;
        vm.errMsg = err;
      }
    },


    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.$store.dispatch('put', {url: "/ratingset/" + vm.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "ratingsetlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    Promise.all([await this.loadRatingSetHandler(), await this.loadRatingDetailsHandler()])
      .then(() => {
        this.loading = false;
      })
      .catch((err) => {
        this.isErr = true;
        this.errMsg = err;
      });
  },
};
</script>